import * as swcHelpers from '@swc/helpers';
import { isDefined } from '@grandvisionhq/utils';
import { getBrandModelAttributes } from '../utils/get-brand-model-attributes.js';
import { getFaceShapes } from '../utils/get-face-shapes.js';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSunglassesProductFeatures } from '../utils/product-feature-mappers/get-sunglasses-product-features.js';
import { mapServerToSunglassesSpecifications } from '../specification-mappers/map-server-to-sunglasses-specifications.js';
import { mapServerToVariantBase } from './map-server-to-variant-base.js';
import { getSharedFrameVariantProps } from './shared/get-shared-frame-variant-props.js';

const mapServerToSunglassesVariant = (serverProduct, slug, locale, priceSegmentChannelKey)=>{
    const { variants: serverVariants  } = serverProduct;
    if (!serverVariants || !serverVariants.length) {
        return;
    }
    const clientVariants = serverVariants.map((serverVariant)=>{
        const variantBase = mapServerToVariantBase(serverVariant, serverProduct, slug, locale, priceSegmentChannelKey);
        if (!variantBase) return;
        const { variantTypeDetails  } = serverVariant;
        const { brand  } = serverProduct;
        const brandModelAttributes = getBrandModelAttributes(serverVariant);
        var _lensFeatures;
        const productFeatures = getSunglassesProductFeatures((_lensFeatures = variantTypeDetails.lensFeatures) !== null && _lensFeatures !== void 0 ? _lensFeatures : {});
        const specifications = mapServerToSunglassesSpecifications(serverVariant, brand, locale, !!serverProduct.productTypeDetails.isOfferedWithPrescriptions);
        const sunglasses = swcHelpers.objectSpread({}, variantBase, getSharedFrameVariantProps(variantTypeDetails), brandModelAttributes, {
            variantType: 'sunglasses',
            faceShapes: getFaceShapes(variantTypeDetails.faceShape),
            productFeatures,
            specifications,
            isVtoEnabled: !!variantTypeDetails.isVtoEnabled,
            isReservable: variantTypeDetails.isReservable
        });
        return sunglasses;
    });
    return clientVariants.filter(isDefined);
};

export { mapServerToSunglassesVariant };
//# sourceMappingURL=map-server-to-sunglasses-variant.js.map
